import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useAtomValue, useSetAtom, useAtom } from 'jotai';
import { Table } from '@cyberint/dsc';
import {
  filteredVictimologyState,
  victimologyFiltersState,
  victimologyTempFiltersState
} from '@cyberint/stateful-ui/victimology/VictimologyTable/store/atoms';
import { getColumns } from './utils';
import * as S from './styled';

const getRowId = row => `${row.id}`;

export const RecentAttacksTable = ({ onRowClick }) => {
  const { tableData } = useAtomValue(filteredVictimologyState) || { tableData: [] };
  const setTempFilters = useSetAtom(victimologyTempFiltersState);
  const [filters, setFilters] = useAtom(victimologyFiltersState);

  const onColumnClick = useCallback(
    (value, field) => {
      if (onRowClick) return;
      const updatedFilters = { ...filters, [field]: [...filters[field], value] };

      setFilters(updatedFilters);
      setTempFilters(updatedFilters);
    },
    [filters, onRowClick]
  );

  const columns = useMemo(() => getColumns(onColumnClick), [onColumnClick]);

  return (
    <S.TableWrapper>
      <Table
        data={tableData}
        columns={columns}
        getRowId={getRowId}
        enableRowSelection={false}
        dataTestId="table-victimology-card"
        initialState={{}}
        onRowClick={onRowClick}
        totalCount={tableData.length}
      />
    </S.TableWrapper>
  );
};

RecentAttacksTable.propTypes = {
  onRowClick: PropTypes.func
};
